import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

const initialState = {
  products: [
    {
      productId: 'p1001',
      name: 'Instant Cash',
      usersCount: 2204,
    },
    {
      productId: 'p1002',
      name: 'Personal Loan',
      usersCount: 5000,
    },
    {
      productId: 'p1003',
      name: 'Salary Advance',
      usersCount: 6000,
    },
  ],
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    updateUserCount: (state, action) => {
      const productId = action.payload;
      const productIndex = state.products.findIndex(
        (product) => product.productId === productId
      );
      state.products[productIndex].usersCount += 1;
    },
  },
});

export function useProductsStore() {
  const products = useSelector((state) => state.products.products);
  const dispatch = useDispatch();
  return {
    products,
    updateUser: (productId) => dispatch(updateUserCount(productId)),
  };
}

export const { updateUserCount } = productsSlice.actions;

export default productsSlice.reducer;
